import { NoticeBoardHeaderList } from '../model/api/notice';
import { sendPost } from './common';

export async function getUserNoticeBoards() {
	const res = await sendPost<NoticeBoardHeaderList>('/manage/get-user-notice-board-list/', {});

	return res.data.notice_board_list;
}
